import { Text } from '@factorialco/deprecated-design-system'
import { ProjectionKind, useDocumentsDataTable } from 'generated/resources/datatable.graphql'

import { dateBackendDateTimeToUI } from 'modules/core/lib/dates'
import i18n from 'modules/core/lib/i18n'

type DocumentsDataTableProjection = Parameters<typeof useDocumentsDataTable>[0][number]

const createdAtProjection: () => DocumentsDataTableProjection = () => ({
  identifier: 'createdAt',
  title: i18n.t('documents.employee.list.created_at'),
  kind: ProjectionKind.Custom,
  template: '',
  render: ({ createdAt }) => <Text size="200">{dateBackendDateTimeToUI(createdAt)}</Text>,
  sortBy: 'createdAt',
  colSpan: 1,
})

export default createdAtProjection
